import { getTokenLocal } from "../utils/localStorage.util";
import ApiRoutes from "../conffigs/endpoints.config";
import HttpClient from "./index.api";
const baseURL = process.env.REACT_APP_API_URL;

class WeeklySettlementApi extends HttpClient {
  constructor() {
    super(baseURL);
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${getTokenLocal()}`;
      return config;
    });
  };

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (response) => {
        return Promise.resolve(response);
      }
    );
  };

  RunConfig = ApiRoutes.WeeklySettlement.Run;
  HistoryConfig = ApiRoutes.WeeklySettlement.History;
  LedgerConfig = ApiRoutes.WeeklySettlement.Ledger;
  AssignKitConfig = ApiRoutes.WeeklySettlement.AssignKit;
  ListKitsConfig = ApiRoutes.WeeklySettlement.ListKits;
  CreateKitOrderConfig = ApiRoutes.WeeklySettlement.CreateKitOrder;
  PurchaseKitConfig = ApiRoutes.WeeklySettlement.PurchaseKit;
  MyKitStatusConfig = ApiRoutes.WeeklySettlement.MyKitStatus;

  runWeeklySettlement = async (data = {}) => {
    return this.instance({
      method: this.RunConfig.Method,
      url: this.RunConfig.Endpoint,
      data: data,
    });
  };

  getWeeklySettlementHistory = async (params = {}) => {
    return this.instance({
      method: this.HistoryConfig.Method,
      url: this.HistoryConfig.Endpoint,
      params: params,
    });
  };

  getIncentiveLedger = async (params = {}) => {
    return this.instance({
      method: this.LedgerConfig.Method,
      url: this.LedgerConfig.Endpoint,
      params: params,
    });
  };

  assignJoiningKit = async (data = {}) => {
    return this.instance({
      method: this.AssignKitConfig.Method,
      url: this.AssignKitConfig.Endpoint,
      data: data,
    });
  };

  getJoiningKits = async (params = {}) => {
    return this.instance({
      method: this.ListKitsConfig.Method,
      url: this.ListKitsConfig.Endpoint,
      params: params,
    });
  };

  createKitOrder = async (data = {}) => {
    return this.instance({
      method: this.CreateKitOrderConfig.Method,
      url: this.CreateKitOrderConfig.Endpoint,
      data: data,
    });
  };

  purchaseJoiningKit = async (data = {}) => {
    return this.instance({
      method: this.PurchaseKitConfig.Method,
      url: this.PurchaseKitConfig.Endpoint,
      data: data,
    });
  };

  getMyKitStatus = async (params = {}) => {
    return this.instance({
      method: this.MyKitStatusConfig.Method,
      url: this.MyKitStatusConfig.Endpoint,
      params: params,
    });
  };

  getAdminJoiningKits = async (params = {}) => {
    return this.instance({
      method: ApiRoutes.WeeklySettlement.AdminListKits.Method,
      url: ApiRoutes.WeeklySettlement.AdminListKits.Endpoint,
      params: params,
    });
  };

  updateJoiningKit = async (data = {}) => {
    return this.instance({
      method: ApiRoutes.WeeklySettlement.AdminUpdateKit.Method,
      url: ApiRoutes.WeeklySettlement.AdminUpdateKit.Endpoint,
      data: data,
    });
  };

  createJoiningKit = async (data = {}) => {
    return this.instance({
      method: ApiRoutes.WeeklySettlement.AdminCreateKit.Method,
      url: ApiRoutes.WeeklySettlement.AdminCreateKit.Endpoint,
      data: data,
    });
  };
}

export default WeeklySettlementApi;
